import Text from '~/components/Text';

interface Props {
  name: string;
  title: string;
  description: string;
}

const FormHeader = ({ name, title, description }: Props) => {
  return (
    <div>
      <div className="relative mb-1 mt-1 inline-flex items-center space-x-1 overflow-hidden rounded-wt px-2 py-1 text-xs">
        <div className="absolute inset-0 bg-wt-primary text-wt-primary opacity-10" />
        <span className="z-10 font-medium text-wt-primary">{name}</span>
      </div>
      <Text as="h1" size={'3xl'} weight="bold" theme="default" type="title">
        {title}
      </Text>
      {description && (
        <Text as="h4" size={'lg'} weight="light" theme="default" type="body">
          {description}
        </Text>
      )}
    </div>
  );
};

export default FormHeader;
